import React from "react";
import { fmtMoneyShort } from "../lib/appUtils";

// Compact circular progress ring for target tracking
export default function ProgressRing({ actual, target, color = "#4F6BFF", label, size = 60 }) {
  const pct = target > 0 ? Math.min(100, Math.round((actual / target) * 100)) : 0;
  const r = (size - 8) / 2;
  const c = 2 * Math.PI * r;
  const off = c - (pct / 100) * c;
  return (
    <div className="flex flex-col items-center gap-1" data-testid={`ring-${label}`}>
      <div className="relative" style={{ width: size, height: size }}>
        <svg width={size} height={size} className="-rotate-90">
          <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="#eef2f7" strokeWidth={6} />
          <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke={color} strokeWidth={6} strokeLinecap="round"
            strokeDasharray={c} strokeDashoffset={off} style={{ transition: "stroke-dashoffset 0.6s ease" }} />
        </svg>
        <span className="absolute inset-0 flex items-center justify-center text-xs font-bold" style={{ color }}>{pct}%</span>
      </div>
      <p className="text-[10px] text-slate-500 text-center leading-tight">{label}</p>
      <p className="text-[10px] text-slate-400 -mt-0.5">{fmtMoneyShort(actual)}/{target > 0 ? fmtMoneyShort(target) : "—"}</p>
    </div>
  );
}
